import React, { useEffect, useState, useRef } from 'react';
import useApp from 'hooks/useApp'
import { Button, Logo, LayerBottom, NoData } from 'components'
import { Link, useNavigate } from 'react-router-dom'
import styles from '../index.module.css'
import { useRecoilValue, atom, useRecoilState, useSetRecoilState } from 'recoil'
import { resultDataState, resultDataSelector, certFromState } from '../states'
import useCommonIndustry from 'hooks/useCommonIndustry'
import Lib from 'library'

const failListState = atom({
	key: "failListState",
	default: false
})

const DataLinkResult = () => {

	const App = useApp()
	const setCertFrom = useSetRecoilState(certFromState)
	const [resultData, setResultData] = useRecoilState(resultDataState)
	const { successList, failList } = useRecoilValue(resultDataSelector)
	const industries = useCommonIndustry()
	const setShowFailLayer = useSetRecoilState(failListState)
	const [showed, setShowed] = useState(false)
	const [buttondisabled, setButtonDisabled] = useState(true)
	const navigate = useNavigate()
	const didSet = useRef(false)

	const onNext = () => {
		setCertFrom("detail")
		console.log('페이지 이동 전 resultData >> ', resultData)
		navigate("/data/transmitRequest")
	}

	const onCheck = id => {
		let count = 0
		const newData = resultData.map(org => {
			const newOrg = Lib.deepCopy(org)
			const newTargetList = newOrg.targetInfoList?.map(target => {
				const newTarget = Lib.deepCopy(target)
				const newAssetList = newTarget.asset_list.map(asset => {
					const newAsset = Lib.deepCopy(asset)
					if (`${newAsset.asset}_${newAsset.seqno}` === id) {
						newAsset.checked = !newAsset.checked
					}
					if (newAsset.checked) count++
					return newAsset
				})
				newTarget.asset_list = newAssetList
				return newTarget
			})
			newOrg.targetInfoList = newTargetList

			return newOrg
		})
		console.log('선택 시 newData', newData)
		setButtonDisabled(count < 1)
		setResultData(newData)
	}

	useEffect(() => {
		if (resultData && !didSet.current) {
			didSet.current = true
			const newResult = Lib.deepCopy(resultData)

			console.log("resultData", resultData);
			console.log("newResult", newResult);

			let count = 0
			newResult?.forEach(org => {
				org.targetInfoList?.forEach(target => {
					target.asset_list.forEach(asset => {
						if (typeof asset.checked === "undefined") {
							asset.checked = true
							count++
						} else if (asset.checked === true) {
							count++
						}
					})
				})
			})
			setButtonDisabled(count < 1)
			setResultData(newResult)
		}
	}, [resultData])

	useEffect(() => {
		if (!showed && failList && failList.length) {
			setTimeout(() => {
				setShowFailLayer(true)
				setShowed(true)
			}, [500])
		}
	}, [failList])

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		console.log({successList})
	}, [])

	return (
		<div className="page pb_100">
			{
				successList &&
					successList.length > 0 ?
					<>
						<div className="flex_1">
							<div className={`${styles["count-group"]} padding`}>
								<p>개인신용정보 목록 선택</p>
								<div><span>1</span>/3</div>
							</div>
							<div className="padding pt_10">
								<ul className="check-area">
									{
										successList.map((item, index) => {
											return (
												<li key={index}>
													<div className="check-title">{
														industries &&
														(() => {
															for (let industry of industries) {
																if (industry.commCd.toLowerCase() === item.indstCd) return industry.commNm
															}
														})()
													}</div>
													{
														item.data.map((org, index) => {
															return (
																org.targetInfoList.map((item, index) => {
																	return (
																		item.asset_list.map((asset, index) => {
																			return (
																				<div key={index} className="check-list" onClick={() => onCheck(`${asset.asset}_${asset.seqno}`)}>
																					<div>
																						<div style={{ width: "calc(100% - 4rem)" }}>
																							<div className="img-box img-symbol">
																								<Logo code={org.insttCd} style={{ width: "100%", height: "100%" }} />
																							</div>
																							<div className="ml_10 flex_1" style={{ width: "calc(100% - 4rem)", paddingRight: "4rem" }}>
																								<p className="nowrap ellipsis">{asset.assetNm}</p>
																								<div className="nowrap flex-align_center flex-align_start">
																									<span className="list-info ellipsis">{org.insttNm}</span>
																									<span className="list-info ml_10 ellipsis flex_1">{asset.asset}</span>
																								</div>
																							</div>

																						</div>
																						<span className={`checkMark${asset.checked ? " on" : ""}`} />
																					</div>
																				</div>
																			)
																		})
																	)
																})
															)
														})
													}
												</li>
											)
										})
									}
								</ul>
							</div>
						</div>
						<div className="flex-shrink_0 padding btn--fixed">
							<Button className="btn btn--big" disabled={buttondisabled} onClick={onNext}>다음</Button>
						</div>
					</>
					:
					<>
						<div className={`${styles["count-group"]} padding`}>
							<p>개인신용정보 목록 선택</p>
							<div><span>1</span>/3</div>
						</div>

						<NoData text={<>전송요구 가능한<br />정보제공기관이 없습니다.</>} />
						<div className="flex-shrink_0 padding btn-group flex-full">
							<Link to="/"><Button className="btn btn--big btn--gray">메인으로 가기</Button></Link>
							<Link to="/data"><Button className="btn btn--big ml_10">재시도</Button></Link>
						</div>
					</>
			}
			<FailListLayer />
		</div>
	)
}

const FailListLayer = () => {

	const [showFailLayer, setShowFailLayer] = useRecoilState(failListState)
	const { failList } = useRecoilValue(resultDataSelector)

	return (
		<LayerBottom show={showFailLayer} closeLayer={() => setShowFailLayer(false)}>
			<div className="page">
				<div className="flex_1">
					<h3 style={{ fontWeight: 500 }}>불러오지 못한<br />기관을 확인해보세요.</h3>
					<div className="check-area mt_20">
						<div className="check-list">
							{
								failList &&
								failList.map((item, index) => {
									return (
										item.data.map((org, index) => {
											return (
												<div key={index} className="justify_start">
													<div className="img-box img-symbol">
														<Logo code={org.insttCd} style={{ width: "100%", height: "100%" }} />
													</div>
													<div className="ml_10 block">
														<p>
															{org.insttNm}&nbsp;
															({
																(() => {
																	return {
																		bank: "은행",
																		card: "카드",
																		invest: "금융투자",
																		insu: "보험",
																		efin: "전자금융",
																		capital: "할부금융",
																		ginsu: "보증보험",
																		telecom: "통신",
																		p2p: "P2P",
																		bond: "인수채권",
																		usury: "대부"
																	}[org.indstCd]
																})()
															})
														</p>
														<span className="list-info">{org.errDesc}</span>
													</div>
												</div>
											)
										})
									)
								})
							}
						</div>
					</div>
				</div>
				<div className="flex-shrink_0 mt_20">
					<Button className="btn btn--big" onClick={() => setShowFailLayer(false)}>확인</Button>
				</div>
			</div>
		</LayerBottom>
	)
}

export default DataLinkResult